/*
 * @Author: jay
 * @Date: 2021-08-25 10:03:38
 * @LastEditTime: 2021-08-25 10:04:46
 * @Description: file content
 */
import { createFromIconfontCN } from '@ant-design/icons';

const IconFont = createFromIconfontCN({
    // scriptUrl: ['//at.alicdn.com/t/font_2767005_k37p610nhcf.js?=1'],
    // scriptUrl: ['//at.alicdn.com/t/font_2767005_143opd28cqqh.js'],
    // scriptUrl: ['//at.alicdn.com/t/font_2767005_kovdicilseo.js'],
    // scriptUrl: ['//at.alicdn.com/t/font_2767005_a99cm8jf31.js',
    scriptUrl: ['//at.alicdn.com/t/c/font_2767005_351yl9x2frt.js'],
});

export default IconFont;
